<template>
  <div id="past-alerts-table-container">
    <div class="pa-header">
      Past Leaks
    </div>
    <div class="pa-container">
      <v-data-table
        :headers="headers"
        :items="pastAlertsData.leakAlertList"
        hide-default-footer
      />
    </div>
  </div>
</template>

<script>
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'PastLeakAlertsTable',
  mixins: [leadDetailMixin],
  data() {
    return {
      headers: [{
        text: 'Location',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'location',
      }, {
        text: 'Start Date',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'startDate',
      }, {
        text: 'End Date',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'endDate',
      }],
    };
  },
};
</script>

<style lang="scss">

#past-alerts-table-container {
  display: flex;
  flex-direction: column;
  .pa-header {
    font-weight: 800;
    color: $N100;
    margin-bottom: 10px;
    font-size: 12pt;
  }
  .pa-container {
    position: relative;
    .v-data-table__wrapper {
      max-height: 400px;
      thead {
        tr {
          th {
            background-color: $N100;
            height: 30px;
            color: $WHITE;
            font-size: 8pt;
            font-weight: 500;
            text-transform: uppercase;
          }
        }
      }
      tbody {
        tr {
          td {
            height: 30px;
            font-size: 8pt;
            border: 0;
          }
          &:nth-child(even) {
            background-color: $N5;
          }
        }
      }
    }
  }
}
</style>
